import { render, staticRenderFns } from "./BarChartVergleichVorjahr.vue?vue&type=template&id=62d9f35e&"
import script from "./BarChartVergleichVorjahr.vue?vue&type=script&lang=js&"
export * from "./BarChartVergleichVorjahr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports